<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g>
    <g>
      <path class="filled" d="M16,6.078A9.922,9.922,0,1,0,25.922,16,9.922,9.922,0,0,0,16,6.078ZM20.856,17.4H17.4v3.457H14.6V17.4H11.144V14.6H14.6V11.144h2.8V14.6h3.456Z" fill="currentColor"/>
      <polygon class="cutout" points="17.4 11.144 14.6 11.144 14.6 14.6 11.144 14.6 11.144 17.4 14.6 17.4 14.6 20.857 17.4 20.857 17.4 17.4 20.856 17.4 20.856 14.6 17.4 14.6 17.4 11.144" fill="#fff"/>
    </g>
    <rect width="32" height="32" fill="none"/>
  </g>
</svg>
